module.exports = __webpack_public_path__ + "static/media/ameritas.1248985e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/ameritas.png
// module id = 29
// module chunks = 0